//-----------------------------------
// calc integrations total (for pow)
//-----------------------------------
export default function calcIntegsTotal({ runes }) {
  // console.log('----------------------')
  // console.log('IN calcIntegsTotal')
  // console.log('runes = ', runes)

  const toBooleanFlag = (value) => {
    return value === true || value === 'true' || value === 1 || value === '1'
  }

  if (!Array.isArray(runes)) {
    return 0
  }

  let result = runes.filter((r) => {
    if (!r) return false

    const isIntegrated = toBooleanFlag(r.integrated)
    const isStarter = toBooleanFlag(r.starter)

    return isIntegrated && !isStarter
  }).length
  console.log('calcIntegsTotal = ', result)
  return result
}
